import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'
import { Marketdata } from '@fortem-monorepo/web-sdk'

import { useRunMarketdataJobMutation } from '@/react-query/mutations/marketdata'

import { type SchemaType, schema } from './RunMarketDataJobsForm.schema'

export interface RunMarketDataJobsFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const RunMarketDataJobsForm: React.FC<RunMarketDataJobsFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)
  const runMarketdataJobMutation = useRunMarketdataJobMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (data) => {
        await runMarketdataJobMutation.mutateAsync(toRunMarketdataJobParams(data))
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}

export const toRunMarketdataJobParams = (data: SchemaType): Marketdata.RunMarketdataJobParams => {
  return {
    value_date: data.value_date,
    chosen_jobs: data.chosen_jobs.length > 0 ? data.chosen_jobs : undefined,
    force_historical: data.force_historical,
    only_tickers: data.only_tickers.length > 0 ? data.only_tickers : undefined,
    skip_closed_european: data.skip_closed_european,
    ticker_cooldown_minutes: data.ticker_cooldown_minutes,
    job_cooldown_minutes: data.job_cooldown_minutes,
  }
}
